<template>
    <div id="app">
        <div id="page_loader">
            <div id="page_loader_spinner">
                <!-- <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> -->
                <img id="spinner-img" src="./assets/images/roda.png">
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>


// WEBPACK FOOTER //
// src/App.vue